// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.e95cb5202',
  revision: 'e95cb5202',
  branch: 'develop',
  date: 'Fri, 06 Mar 2026 15:14:39 GMT'
};